// This is a list of exportable collections by admins
// This is used in the app to render a list of the collections and by the function
// to verify that only these collections can be exported
export const exportableCollections = [
    "profiles",
    "privateProfiles",
    "applications",
    "users",
    "listings",
    "roles",
    "taxRates",
    "creditCards",
    "slugs",
    "connections",
];
//# sourceMappingURL=exportable-collections.js.map